<div #mainBox [class.top-box]="isTopBox" [class.bottom-box]="isBottomBox" class="fluencyrate-box pointer"
    (clickOutside)="onClickOutside()" [additionalElementRefs]="extraBoxes">
    <div class="flag flex-column  no-select"  [class.flag-all-trials]="remainingTrials<=0"  (mousedown)="startLongPress()" (mouseup)="endLongPress($event)"
        (mouseleave)="endLongPress($event)" (touchstart)="startLongPress()" (touchend)="endLongPress($event)"
        (touchcancel)="endLongPress($event)"  [class.smaller]="isStarted">

        <div class="duration-container" [class.blinking-effect]="isAlarmRinging" [class.smaller]="isStarted">
            <div *ngIf="isStarted">
                <p-checkbox inputId="happened" name="happened" [ngModel]="happened" [binary]="true" (onChange)="setHappened($event)"></p-checkbox>
                <label for="happened">Happened</label>
            </div>
            <div class="duration-controls"  [class.smaller]="isStarted">
                <button (click)="startTimer()" class="duration-button start-button">{{timerString()}}</button>
                <button *ngIf="isStarted" (click)="cancelTimer()" class="duration-button stop-button">
                    Stop
                </button>
            </div>
            
            <div class="flag-text">{{ text }}
                
            <span class="sd-text">{{target?.DiscriminativeStimulus}}</span>
            </div>
        </div>
        <span class="badge-count" (click)="showExtra2()" [class.badge-count-green]="intervals.length>=expectedAmount"
            [class.badge-count-red]="intervals.length<expectedAmount">{{intervals.length}}/{{expectedAmount}}</span>

        <button class="badge-bottom-left" [class.target-note-new]="target?.HasUnreadTargetNoteForStaff" (click)="openDetails($event)" >?</button>
        <button class="badge-bottom-right" (click)="openDetails($event)" title="Remaining desired Trials" *ngIf="remainingTrials>0"> {{remainingTrials}}</button>  
    </div>
</div>
@if (detailsOpened) {
<app-target-details [target]="target" (onCloseDetails)="onCloseDetails()" [isPreview]="isPreview"></app-target-details>
}

<div class="extra-container" #extraBox [class.hide]="!extraOpened">
    <div class="extra-container-textbox">
        <div class="score-buttons">
            <p-checkbox inputId="happened-extra" [ngModel]="happened" [binary]="true" (onChange)="setHappened($event)"></p-checkbox>
            <label for="happened-extra">Happened</label>
        </div>
    </div>
</div>

<div class="extra-container" #extraBox2 [class.hide]="!extra2Opened">
    <div class="extra-close" (click)="closeExtra2()">X</div>
    <div class="extra-container-textbox">
        <div *ngFor="let interval of intervals">
            <div class="float-right extra-list-trash-icon pointer" (click)="deleteData(interval)"><i class="pi pi-trash"></i></div>
            <div>{{ interval.FormattedDate }}</div>
            <div>{{ interval.happened ? 'Happened' : "Didn't happen" }}</div>
        </div>
    </div>
</div>
